<div style="height: 100%">
  <div (click)="clicked(category)" *ngFor="let category of categories" style="border: solid grey 0.0px; width: 84px; margin: 0; padding: 0; height: 20px"
       [style.background-color]="colors[category]" [style.color]="'black'"
       [title]="type + ' ' + category + ': ' + data[category] + units">
<!--    <mat-icon *ngIf="icons[category]">{{icons[category]}}</mat-icon>-->
    <span style="font-size: 12pt; vertical-align: super; margin-left: 3px; width: 12px;">{{data[category]}}</span>
    <span style="font-size: 12pt; vertical-align: super; margin-left: 3px;">{{category}}</span>
  </div>
</div>
